import { render, staticRenderFns } from "./MultipleButtonModal.vue?vue&type=template&id=f2b2c44e&scoped=true"
import script from "./MultipleButtonModal.vue?vue&type=script&lang=js"
export * from "./MultipleButtonModal.vue?vue&type=script&lang=js"
import style0 from "./MultipleButtonModal.vue?vue&type=style&index=0&id=f2b2c44e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b2c44e",
  null
  
)

export default component.exports